module.exports = __webpack_public_path__ + "static/media/capture1.1a1fd1e2.PNG";